import React from 'react';
import PropTypes from 'prop-types';
import { Slider } from '@mui/material';
import useStyles from './styles';
export default function RangeSlider(_ref) {
  let isDisabled = _ref.isDisabled,
    labelFormat = _ref.labelFormat,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? 0 : _ref$value,
    handleChange = _ref.handleChange,
    minValue = _ref.minValue,
    maxValue = _ref.maxValue,
    stepValue = _ref.stepValue;
  const classes = useStyles();
  const getLabel = () => labelFormat === 'percentage' ? "".concat(value, "%") : "$".concat(value);
  const valuetext = val => {
    return "".concat(val);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.slider
  }, /*#__PURE__*/React.createElement(Slider, {
    "aria-label": "amf",
    disabled: isDisabled,
    value: value,
    getAriaValueText: valuetext,
    valueLabelFormat: v => getLabel(v),
    valueLabelDisplay: "auto",
    step: stepValue !== null && stepValue !== void 0 ? stepValue : 1,
    marks: true,
    min: minValue !== null && minValue !== void 0 ? minValue : 0,
    max: maxValue !== null && maxValue !== void 0 ? maxValue : 10,
    onChange: handleChange
  }));
}
RangeSlider.propTypes = {
  value: PropTypes.number
};